import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig"; // adjust the path to your firebase.js config

export const getCategoryMap = async () => {
  const snapshot = await getDocs(collection(db, "categories"));
  const map = {};
  snapshot.forEach((doc) => {
    const data = doc.data();
    // Choose language fallback: pl > en > it
    const name =
      data.name?.pl || data.name?.en || data.name?.it || "Nieznana kategoria";
    map[doc.id] = name;
  });
  return map;
};
